const updateGamePicker = (state = {}, action) => {
    const { type = null, datasource } = action
    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {

        return {
            ...state,
            date: action.data?.gameData?.datetime?.dateTime,
            gamePk: action.data?.gameData?.game?.pk,
            sportId: action.data?.gameData?.teams?.home?.sport?.id,
            homeLeagueId: action.data?.gameData?.teams?.home?.league?.id,
            awaySportId: action.data?.gameData?.teams?.home?.sport?.id,
            awayLeagueId: action.data?.gameData?.teams?.away?.league?.id
        };
    }
    if (type === 'dataEngine_update_response') {
        if (datasource === 'productConfig') {
            const {sports} = action?.data?.context?.sloFilters?.sloFilters || {};
            const sportId = state?.sportId;
            let leagueList;

            if (sports && sportId) {
                leagueList = sports?.[sportId]?.leagueList?.split(','); 
            }

            if (!leagueList) {
                return state
            }
            
            return {
                ...state,
                leagues: leagueList
            }
        }
    }

    return state;
};

export default updateGamePicker;